import axiosInstance from "@/lib/axiosInstance";
import { getApiErrorMessage } from "@/lib/apiError";
import type {
  MarkNotificationsReadResponseDO,
  PortalNotificationsResponseDO,
  PortalUnreadCountResponseDO,
} from "@/types/notification";

const NOTIFICATIONS_BASE_PATH = "/notifications";

export const notificationService = {
  async fetchNotifications(): Promise<PortalNotificationsResponseDO> {
    try {
      const response = await axiosInstance.get<PortalNotificationsResponseDO>(
        NOTIFICATIONS_BASE_PATH,
      );

      return response.data;
    } catch (error) {
      throw new Error(
        getApiErrorMessage(error, "Failed to fetch notifications."),
      );
    }
  },

  async fetchUnreadCount(): Promise<PortalUnreadCountResponseDO> {
    try {
      const response = await axiosInstance.get<PortalUnreadCountResponseDO>(
        `${NOTIFICATIONS_BASE_PATH}/unread-count`,
      );

      return response.data;
    } catch (error) {
      throw new Error(
        getApiErrorMessage(
          error,
          "Failed to fetch unread notifications count.",
        ),
      );
    }
  },

  async markAllAsRead(): Promise<MarkNotificationsReadResponseDO> {
    try {
      const response =
        await axiosInstance.patch<MarkNotificationsReadResponseDO>(
          `${NOTIFICATIONS_BASE_PATH}/mark-read`,
        );

      return response.data;
    } catch (error) {
      throw new Error(
        getApiErrorMessage(error, "Failed to mark notifications as read."),
      );
    }
  },
};
